// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_gRYmc){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3qcwE .dualColumn_BKEjq{display:flex;align-content:space-between}.nsAddressForm_3qcwE .dualColumn_BKEjq .firstCol_2HKcF{margin-right:20px}.optional_2UF_O{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_gRYmc",
	"nsAddressForm": "nsAddressForm_3qcwE",
	"dualColumn": "dualColumn_BKEjq",
	"firstCol": "firstCol_2HKcF",
	"optional": "optional_2UF_O"
};
module.exports = exports;
